// extracted by mini-css-extract-plugin
export default {"backButton":"backButton_backButton__R28B8","label":"backButton_label__EEAWG"};